import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

/**
 * @param date A date object to set the initial date time..
 * To create ISO string with offset, special for java-jackson OffsetDateTime deserialization
 * @return {string} ISO string with offset
 */
export function getISOStringWithOffset(date) {
  return getUtcTime(date).format('YYYY-MM-DDTHH:mm:ss.SSSZZ');
}

export function getTime() {
  return Date.now();
}

export function getUtcTime(date) {
  return dayjs(date).utc();
}

/**
 * Helper methods implemented by third party libraries like jquery
 */
export default class Helpers {
  /**
   * Enable a smooth expand & shrink animation for a text type input when focus.
   * This method uses jquery
   *
   * @param  {input} input[type='text'] dom element
   */

  /**
   * Insert a piece of code with typing animation
   * @param  {editor}  editor     ace editor instance
   * @param  {string}  code       code string
   * @param  {boolean} newLine    make false to insert same line not a new line
   * @param  {boolean} immidate   set true to insert without animation
   * @param  {function} callback  callback to execute when insert finished
   */
  static insertCode(
    editor,
    code,
    newLine,
    immidate = false,
    callback = () => null
  ) {
    let cursorPos = editor.getCursorPosition();

    if (code === '') {
      editor.focus();
      let before = editor.session
        .getLine(cursorPos.row)
        .substr(0, cursorPos.column);

      // handle scopes
      if (before.endsWith(':')) {
        editor.session.insert(
          {
            row: editor.session.getLength(),
            column: 0
          },
          '\n' + '  '
        );
        editor.navigateFileEnd();
      } else {
        // move cursor to method parameters
        let index = before.lastIndexOf('(');
        if (index > -1) {
          editor.moveCursorToPosition({
            row: cursorPos.row,
            column: index + 1
          });
        }
      }

      callback();
      return;
    }

    let insertion = code.substr(0, 2);
    if (immidate === true) {
      insertion = code;
    }

    if (newLine !== false) {
      let beforeText = editor.session.getTextRange(
        new ace.Range(cursorPos.row, 0, cursorPos.row, cursorPos.column)
      );
      let afterText = editor.session.getTextRange(
        new ace.Range(cursorPos.row, cursorPos.column, cursorPos.row)
      );

      let hasBefore = beforeText.trim() != '';
      let beforeIndex = beforeText.trim().length - 1;
      let hasDotBefore =
        beforeText.trim().lastIndexOf('.') == beforeIndex ||
        beforeText.trim().lastIndexOf('=') == beforeIndex;
      let hasAfter = afterText.trim() != '';

      if (hasBefore) {
        editor.navigateLineEnd();
        cursorPos = editor.getCursorPosition();
        editor.session.insert(
          {
            row: cursorPos.row,
            column: cursorPos.column
          },
          (hasDotBefore ? '' : '\n') + insertion
        );
      } else if (hasAfter) {
        editor.session.insert(
          {
            row: cursorPos.row,
            column: cursorPos.column
          },
          '\n'
        );
        editor.navigateUp();
        editor.session.insert(
          {
            row: cursorPos.row,
            column: cursorPos.column
          },
          insertion
        );
      } else {
        editor.session.insert(
          {
            row: cursorPos.row,
            column: cursorPos.column
          },
          insertion
        );
      }
    } else {
      editor.session.insert(
        {
          row: cursorPos.row,
          column: cursorPos.column
        },
        insertion
      );
    }

    if (immidate !== true) {
      setTimeout(() => {
        Helpers.insertCode(editor, code.substr(2), false, false, callback);
      }, 50);
    }
  }
}

export const sleep = (wait) => new Promise((res) => setTimeout(res, wait));

export const safeParse = (string, defaultValue = {}) => {
  try {
    return JSON.parse(string);
  } catch (_err) {
    return defaultValue;
  }
};

export function parseSceneMethods(methods) {
  if (optional(methods).exist()) {
    return methods.reduce((acc, method) => {
      if (method.includes('=')) {
        let [m, value] = method.split('=');
        acc[m] = value;
      } else {
        acc[method] = true;
      }
      return acc;
    }, {});
  }

  return {};
}
